//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from "react-redux";

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Basic Selectors ------------------
const lessonPlansByBookSelector = (state) => state.lessonPlansByBook;
const lessonPlansByBookAndUserSelector = (state) => state.lessonPlansByBookAndUser;

//  -- Hook Selectors ------------------

//  -- Lesson Plans by Book ------------------
export const useLessonPlansByBook = () => {
  const selectedData = useSelector(lessonPlansByBookSelector, shallowEqual);
  return selectedData;
};

//  -- Lesson Plans by Book and User ------------------
export const useLessonPlansByBookAndUser = () => {
  const selectedData = useSelector(lessonPlansByBookAndUserSelector, shallowEqual);
  return selectedData;
};
